import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import * as firebase from 'firebase'
import {store} from './store';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyDiEZD9eP8_JxuXD61qRwAJrnsC46cnOqY',
      authDomain: 'fmimproveplayers.firebaseapp.com',
      databaseURL: 'https://fmimproveplayers.firebaseio.com',
      projectId: 'fmimproveplayers',
      storageBucket: 'fmimproveplayers.appspot.com',
      messagingSenderId: '13266109036'
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }else{
        this.$router.push('/index')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js